// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// Import NPM packages
import 'slick-carousel';
import 'odometer';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateFlexible from './routes/flex';
import templateHome from './routes/home';
import templateTheHistory from './routes/history';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    templateFlexible,
    templateHome,
    templateTheHistory,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js